import React from 'react';
import { NewsfilateHeader } from '../components/NewsfilateHeader';
import { HeroSection } from '../components/HeroSection';
import { WhySection } from '../components/WhySection';
import { FeaturesSection } from '../components/FeaturesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { DemoSection } from '../components/DemoSection';
import { PricingSection } from '../components/PricingSection';
import { CTASection } from '../components/CTASection';
import { NewsfilateFooter } from '../components/NewsfilateFooter';
export function NewsfiliatePage() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1398">
      <NewsfilateHeader data-id="element-1399" />
      <main className="flex-grow" data-id="element-1400">
        <HeroSection data-id="element-1401" />
        <WhySection data-id="element-1402" />
        <FeaturesSection data-id="element-1403" />
        <TestimonialsSection data-id="element-1404" />
        <HowItWorksSection data-id="element-1405" />
        <DemoSection data-id="element-1406" />
        <PricingSection data-id="element-1407" />
        <CTASection data-id="element-1408" />
      </main>
      <NewsfilateFooter data-id="element-1409" />
    </div>;
}